import type { SelectiveOnboardingConfig } from '../types/automation-flow.types';

export enum Environment {
  ALL = 'all',
  Lab = 'lab',
  Production = 'prod'
}

export enum PipelineStatus {
  Success = 'success',
  InProgress = 'in-progress',
  Failure = 'failure',
  Canceled = 'canceled',
  Pending = 'pending',
  Completed = 'completed',
  Banned = 'banned',
  Manual = 'manual',
  Warning = 'warning',
  Aborted = 'aborted',
  Paused = 'paused'
}

/**
 * Predefined workflow stages in their correct order
 */
export enum WorkflowStage {
  Distribution = 'Distribution',
  OciRegistry = 'OCI Registry',
  ArtifactsRetrievingLab = 'Artifacts retrieving LAB',
  ArtifactsOnboardingLab = 'Artifacts Onboarding LAB',
  ArtifactsDeployment = 'Artifacts Deployment',
  Testing = 'Testing',
  ArtifactsRetrievingProd = 'Artifacts retrieving PROD',
  ArtifactsOnboardingProd = 'Artifacts Onboarding PROD'
}

export const WORKFLOW_STAGES_LAB = [
  WorkflowStage.Distribution,
  WorkflowStage.OciRegistry,
  WorkflowStage.ArtifactsRetrievingLab,
  WorkflowStage.ArtifactsOnboardingLab,
  WorkflowStage.ArtifactsDeployment,
  WorkflowStage.Testing
];

export const WORKFLOW_STAGES_PROD = [WorkflowStage.ArtifactsRetrievingProd, WorkflowStage.ArtifactsOnboardingProd];

export interface PipelineStep {
  Step: string;
  Stage: string;
  Status: PipelineStatus;
  TicketId: string;
  timestamp: string;
  Environment: Environment[];
  logs?: string;
}

export interface PipelineItem {
  id: string;
  name: string;
  TicketId: string;
  createdAt: string;
  updatedAt: string;
  status: PipelineStatus;
  currentStage: string;
  currentStep: string;
  environment: Environment[];
  steps: PipelineStep[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: Record<string, any>;
  gnbDeploySubmitted?: boolean;
  automationFlow: {
    id: string;
    name: string;
    cardName: string;
    configuration?: {
      selectiveOnboarding?: SelectiveOnboardingConfig;
      [key: string]: unknown;
    };
    eiapCluster?: {
      id: string;
      name: string;
      category: string;
    };
    cnisEndpoint?: {
      id: string;
      name: string;
      category: string;
    };
  };
}

export interface PaginatedPipelines {
  data: PipelineItem[];
  total: number;
  limit: number;
  offset: number;
  nextPage: number;
}

export type PipelineStats = {
  [key in PipelineStatus]: number;
};

export interface PipelineSummaryStats {
  stats: PipelineStats;
  isLoading: boolean;
  error: string | null;
}

export interface PipelineData {
  paginatedData: PaginatedPipelines;
  isLoading: boolean;
  error: string | null;
}
